import React, { useState } from 'react';
import { SignupData } from '../../../pages/SignupPage';
import { XIcon } from 'lucide-react';
interface JournalistFormProps {
  updateDetails: (details: any) => void;
  data: SignupData;
}
const JournalistForm: React.FC<JournalistFormProps> = ({
  updateDetails,
  data
}) => {
  const [areaInput, setAreaInput] = useState('');
  const handleAddArea = () => {
    if (areaInput.trim() !== '') {
      const currentAreas = data.profileDetails?.coverageAreas || [];
      updateDetails({
        coverageAreas: [...currentAreas, areaInput.trim()]
      });
      setAreaInput('');
    }
  };
  const handleRemoveArea = (index: number) => {
    const currentAreas = [...(data.profileDetails?.coverageAreas || [])];
    currentAreas.splice(index, 1);
    updateDetails({
      coverageAreas: currentAreas
    });
  };
  return <div className="space-y-4" data-id="element-105">
      <div data-id="element-106">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-107">
          Publication/Media Outlet
        </label>
        <input type="text" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" placeholder="e.g. Sports Illustrated, ESPN" value={data.profileDetails?.publication || ''} onChange={e => updateDetails({
        publication: e.target.value
      })} data-id="element-108" />
      </div>
      <div data-id="element-109">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-110">
          Years of Experience
        </label>
        <input type="number" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5" placeholder="e.g. 5" value={data.profileDetails?.experience || ''} onChange={e => updateDetails({
        experience: e.target.value
      })} data-id="element-111" />
      </div>
      <div data-id="element-112">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-113">
          Areas of Coverage
        </label>
        <div className="flex" data-id="element-114">
          <input type="text" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-l-lg block w-full p-2.5" placeholder="e.g. Transfer News, Match Analysis" value={areaInput} onChange={e => setAreaInput(e.target.value)} onKeyPress={e => e.key === 'Enter' && (e.preventDefault(), handleAddArea())} data-id="element-115" />
          <button type="button" className="bg-blue-600 text-white rounded-r-lg px-4" onClick={handleAddArea} data-id="element-116">
            Add
          </button>
        </div>
        <div className="mt-2" data-id="element-117">
          {(data.profileDetails?.coverageAreas || []).map((area, index) => <div key={index} className="flex items-center bg-gray-100 rounded-lg px-3 py-2 mt-2" data-id="element-118">
              <span className="flex-1" data-id="element-119">{area}</span>
              <button type="button" className="text-gray-500 hover:text-red-500" onClick={() => handleRemoveArea(index)} data-id="element-120">
                <XIcon size={16} data-id="element-121" />
              </button>
            </div>)}
        </div>
      </div>
    </div>;
};
export default JournalistForm;